export default "__VITE_ASSET__192bb3f8__"